import { client } from "../client/client";

export const fetchSavingsData = async (page, limit, query, status) => {
  try {
    const statusParam = status === "All" ? "" : `&status=${status}`;
    const response = await client.get(
      `/api/v1/savings?page=${page}&limit=${limit}&q=${query}${statusParam}`
    );
    return response?.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getSavingsSummary = async (id) => {
  const response = await client.get(`/api/v1/savings/member/${id}/summary`);
  return response?.data;
};

export const getPersonalSavingsTranscations = async (page, limit, memberId) => {
  const response = await client.get(
    `/api/v1/savings/transactions?page=${page}&limit=${limit}&memberId=${memberId}`
  );
  return response;
};

export const exportAllSavings = async (type, status = "All", q = "") => {
  // If status is "All", treat it as empty
  const statusParam = status === "All" ? "" : `status=${status}&`;

  const response = await client.get(
    `/api/v1/savings/export?${statusParam}format=${type}${q ? `&q=${q}` : ""}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    }
  );

  return response.data;
};

export const exportMemberSavingsTransactions = async (memberId, type) => {
  const response = await client.get(
    `/api/v1/savings/transactions?memberId=${memberId}&export=${type}`,
    {
      headers: {
        "Content-Type": type === "pdf" ? "application/pdf" : "text/csv",
      },
      responseType: "arraybuffer",
    }
  );

  return response.data;
};
